import { ExternalLinkIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface WabaLink {
  labelKey: string;
  url: string;
}

const WabaSettingsMenu = () => {
  const { t } = useTranslation();

  // WhatsApp Business Manager URLs - Based on 2025-2026 Meta documentation
  // Note: Meta doesn't use WABA IDs directly in URLs; WABA selection happens in the UI
  const links: WabaLink[] = [
    {
      labelKey: 'integrations.whatsapp.waba_settings.business_verification',
      url: 'https://business.facebook.com/settings/security',
    },
    {
      labelKey: 'integrations.whatsapp.waba_settings.payment_methods',
      url: 'https://business.facebook.com/billing_hub/payment_methods',
    },
    {
      labelKey: 'integrations.whatsapp.waba_settings.phone_numbers',
      url: 'https://business.facebook.com/wa/manage/phone-numbers/',
    },
    {
      labelKey: 'integrations.whatsapp.waba_settings.message_templates',
      url: 'https://business.facebook.com/wa/manage/message-templates/',
    },
    {
      labelKey: 'integrations.whatsapp.waba_settings.flows',
      url: 'https://business.facebook.com/wa/manage/flows/',
    },
    {
      labelKey: 'integrations.whatsapp.waba_settings.two_factor',
      url: 'https://business.facebook.com/wa/manage/phone-numbers/',
    },
  ];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline-neutral" size="sm" className="gap-2">
          <ExternalLinkIcon className="size-4" />
          {t('integrations.whatsapp.waba_settings.title')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuLabel>{t('integrations.whatsapp.waba_settings.header')}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {links.map((link) => (
          <DropdownMenuItem key={link.labelKey} asChild>
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between"
            >
              <span className="flex-1">{t(link.labelKey)}</span>
              <ExternalLinkIcon className="size-3.5 text-foreground-muted" />
            </a>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default WabaSettingsMenu;
